/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from "prop-types";
import React from "react";
import "./SelectDropDown.scss";

const deleteIconPropTypes = {
  /**
   * Callback for when the option gets changed
   */
  onClick: PropTypes.func.isRequired,
};

export function DeleteIcon({ onClick = {} }) {
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <div
      role="button"
      tabIndex={0}
      className="Uic-SelectDropDown-close"
      onClick={onClick}
      onKeyDown={onClick}
    >
      <i className="fa fa-xmark" />
    </div>
  );
}

DeleteIcon.propTypes = deleteIconPropTypes;
